import React from 'react';
import { Table, Form, Badge } from 'react-bootstrap';
import { retornaIntervalo } from '../utils/validacao';

const GridResultado = ({ registros, tipoDisparo, selecionados, onToggle, onToggleAll }) => {
  if (!registros || registros.length === 0) {
    return null;
  }

  const elegiveisIds = registros
    .filter((r) => r.mensagem)
    .map((r) => r.codigo_titulo || r.cpf);

  const todosElegiveisSelec = elegiveisIds.length > 0
    && elegiveisIds.every((id) => selecionados.includes(id));

  const getRowId = (r) => (tipoDisparo === 'CONTRATO' ? r.codigo_titulo : r.cpf);

  const getStatusBadge = (status) => {
    if (status === 'OK') return <Badge variant="success">OK</Badge>;
    if (status === 'ERRO') return <Badge variant="danger">ERRO</Badge>;
    return null;
  };

  const colunasPorContrato = (
    <thead>
      <tr>
        <th style={{ width: 40 }}>
          <Form.Check
            type="checkbox"
            checked={todosElegiveisSelec}
            onChange={() => onToggleAll(elegiveisIds, todosElegiveisSelec)}
          />
        </th>
        <th>Empreendimento</th>
        <th>Quadra</th>
        <th>Lote</th>
        <th>GE</th>
        <th>Conta</th>
        <th>Cliente</th>
        <th>Celular</th>
        <th>Dias Atraso</th>
        <th>Mensagem</th>
        <th>Status</th>
      </tr>
    </thead>
  );

  const colunasPorCpf = (
    <thead>
      <tr>
        <th style={{ width: 40 }}>
          <Form.Check
            type="checkbox"
            checked={todosElegiveisSelec}
            onChange={() => onToggleAll(elegiveisIds, todosElegiveisSelec)}
          />
        </th>
        <th>CPF</th>
        <th>Cliente</th>
        <th>Celular</th>
        <th>Intervalo (dias)</th>
        <th>Mensagem</th>
        <th>Status</th>
      </tr>
    </thead>
  );

  return (
    <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '60vh' }}>
      <Table striped bordered hover size="sm" className="mt-2">
        {tipoDisparo === 'CONTRATO' ? colunasPorContrato : colunasPorCpf}
        <tbody>
          {registros.map((r) => {
            const rowId = getRowId(r);
            const temMensagem = !!r.mensagem;
            const estaSelecionado = selecionados.includes(rowId);
            const bgSemMensagem = !temMensagem ? { backgroundColor: '#ffe0e0' } : {};

            if (tipoDisparo === 'CONTRATO') {
              return (
                <tr key={`${r.codigo_titulo}-${r.cpf}`} style={bgSemMensagem}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={estaSelecionado}
                      disabled={!temMensagem}
                      onChange={() => onToggle(rowId)}
                      title={!temMensagem ? 'Sem mensagem configurada para este intervalo' : ''}
                    />
                  </td>
                  <td>{r.nome_familia}</td>
                  <td>{r.mapa1}</td>
                  <td>{r.mapa2}</td>
                  <td>{r.codigo_grupo_empresa}</td>
                  <td>{r.codigo_conta}</td>
                  <td>{r.nome}</td>
                  <td>{r.celular}</td>
                  <td>{r.qtd_atraso}</td>
                  <td style={{ maxWidth: 300 }}>
                    <span title={r.mensagem}>
                      {r.mensagem
                        ? r.mensagem.length > 60
                          ? `${r.mensagem.substring(0, 60)}...`
                          : r.mensagem
                        : <span className="text-danger">Sem mensagem</span>}
                    </span>
                    {r.msg_retorno && (
                      <div className="text-danger" style={{ fontSize: '0.8em' }}>
                        {r.msg_retorno}
                      </div>
                    )}
                  </td>
                  <td>{getStatusBadge(r.status)}</td>
                </tr>
              );
            }

            return (
              <tr key={`${r.cpf}`} style={bgSemMensagem}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={estaSelecionado}
                    disabled={!temMensagem}
                    onChange={() => onToggle(rowId)}
                    title={!temMensagem ? 'Sem mensagem configurada para este intervalo' : ''}
                  />
                </td>
                <td>{r.cpf}</td>
                <td>{r.nome}</td>
                <td>{r.celular}</td>
                <td>{retornaIntervalo(r.de, r.ate)}</td>
                <td style={{ maxWidth: 300 }}>
                  <span title={r.mensagem}>
                    {r.mensagem
                      ? r.mensagem.length > 60
                        ? `${r.mensagem.substring(0, 60)}...`
                        : r.mensagem
                      : <span className="text-danger">Sem mensagem</span>}
                  </span>
                  {r.msg_retorno && (
                    <div className="text-danger" style={{ fontSize: '0.8em' }}>
                      {r.msg_retorno}
                    </div>
                  )}
                </td>
                <td>{getStatusBadge(r.status)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div className="text-muted" style={{ fontSize: '0.9em' }}>
        {selecionados.length} selecionado(s) de {registros.filter((r) => r.mensagem).length} elegível(is){' '}
        ({registros.length} total)
      </div>
    </div>
  );
};

export default GridResultado;
